import React, { useState } from "react";

const ShiftCodesModal = () => {
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  return (
    <div className="modalTest" onClick={() => setShow(false)}>
      <div
        className="w-11/12 max-w-md bg-neutral text-neutral-content p-5 rounded-lg z-10"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-semibold pb-2">
          We've moved on to shiftcodes.ca
        </h2>

        <p className="text-sm pb-3">
          shiftcodes.ca is built by the makers of OHIPcodes.com and has
          everything you're used to here, plus more:
        </p>

        <ul className="text-sm list-disc pl-5 pb-3 space-y-1">
          <li>Real AI-assisted code lookup</li>
          <li>Updated for the April 1 Schedule of Benefits</li>
          <li>Corrected codes</li>
          <li>More accurate fees</li>
          <li>An "outside OHIP" calculator</li>
        </ul>

        <div className="flex justify-end gap-2">
          <button
            onClick={() => setShow(false)}
            className="btn btn-ghost m-0 btn-xs"
          >
            Maybe later
          </button>
          <a
            href="https://shiftcodes.ca"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn btn-info m-0 btn-xs">
              Try shiftcodes.ca
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ShiftCodesModal;
